/**
 * Util file for all app deployment related helpers 
 */

export const getAppStage = () => {
    return process.env.NEXT_PUBLIC_SST_STAGE
}

export const isDevEnvironment = (): boolean => {
    return getAppStage() === "dev"
}

export const isStagingEnvironment = (): boolean => {
    return getAppStage() === "staging"
}

export const isProdEnvironment = (): boolean => {
    return getAppStage() === "prod"
}
